import React, { Component } from 'react'
import { connect } from 'react-redux'
import AccessResult from './AccessResult'
import TicketResult from './TicketResult'
import ReferenceResult from './ReferenceResult'
import OrderEventResult from './OrderEventResult'
import http from 'API/http'
import axios from 'axios'
const CancelToken = axios.CancelToken

class SmallSearch extends Component {
  constructor (props) {
    super(props)
    this.state = {
      menu: false,
      endpoint: '2.4/accesses/search/',
      search: 'Accesses',
      icon: 'fa-home',
      location: 1,
      fieldFocused: false,
      loading: false,
      totalResults: 0
    }
    this.timer = null
    this.cancelToken = CancelToken.source()
  }

  componentWillReceiveProps (props) {
    if (props.navigation.path === this.props.navigation.path) return
    var search = props.navigation.path === '/ticket' ? 'Tickets' : 'Accesses'
    this.setState({
      search: search,
      limit: 10,
      offset: 0,
      endpoint: (search === 'Tickets' ? '2.4/tickets/search/' : '2.4/accesses/search/'),
      icon: (search === 'Tickets' ? 'fa-ticket' : 'fa-home')
    })
  }

  componentDidMount () {
    var pos
    this.clearSearch()
    document.addEventListener('keydown', (event) => {
      if (this.props.search.results && this.props.search.results && this.props.search.results.length) {
        switch (event.keyCode) {
          case 40:
            pos = this.state.location + 1
            if (pos > this.props.search.results.length) {
              pos = 1
            }
            return (this.setState({location: pos}))
          case 38:
            pos = this.state.location - 1
            if (pos < 1) {
              pos = this.props.search.results.length
            }
            return (this.setState({location: pos}))
          case 13:
            window.location = (window.location.hash.indexOf('ticket') === -1 ? ('#/access/' + this.props.search.results[this.state.location - 1].accessId) : ('#/ticket/' + this.props.search.results[this.state.location - 1].ticketRef))
            return (this.clearSearch())
          case 27:
            return (this.clearSearch())
        }
      }

      if (event.keyCode === 13 && !this.props.search.results && this.state.fieldFocused) {
        this.dispatchQuery(this.searchField.value, (window.location.hash.indexOf('ticket') === -1))
      } else if (!this.searchField.value.length) {
        this.clearSearch()
      }
    }, false)

  }

  handleChange (event) {
    this.setState({loading: true})
    var query = event.target.value
    clearTimeout(this.timer)
    this.timer = setTimeout(() => {
      this.dispatchQuery(query)
    }, 350)
  }
  async dispatchQuery (query) {
    if (query.length === 0) return
    this.clearSearch()
    this.cancelToken.cancel()
    let cancelToken = CancelToken.source()
    this.cancelToken = cancelToken
    var err, res
    if (this.state.pathparam) {
      [err, res] = await http.get(this.state.endpoint + query, {detailed: true}, null, { cancelToken: cancelToken.token })
    } else {
      [err, res] = await http.get(this.state.endpoint, {search: query, limit: 10, offset: 0, detailed: true}, null, { cancelToken: cancelToken.token })
    }

    if (err) return this.setState({loading: false})
    if (!Array.isArray(res.data)) res.data = [res.data]
    this.props.dispatch({
      type: 'SET_SEARCH',
      payload: {
        query: query,
        results: res.data,
        total: res.headers['x-total-count']
      }
    })
    this.setState({loading: false, totalResults: res.headers['x-total-count']})
  }
  clearSearch () {
    this.props.dispatch({
      type: 'SET_SEARCH',
      payload: {
        query: '',
        total: 0,
        results: []
      }
    })
  }
  render () {
    var i = 0
    return (
      <div className='navbar-form navbar-right navbar-search search form-group access-small-search'>
        <div className='input-group'>
          <span className='input-group-addon' onClick={(e) => { this.setState({menu: !this.state.menu}) }}>
            <i className={'fa fa-fw ' + this.state.icon} />
            <div className={'search-index-menu ' + (this.state.menu ? '' : 'hidden')}>
              <a onClick={() => { this.setState({icon: 'fa-home', endpoint: '2.4/accesses/search/', search: 'Accesses', pathparam: false}, this.clearSearch()) }}><i className='fa fa-fw fa-home' /></a>
              <a onClick={() => { this.setState({icon: 'fa-handshake-o', endpoint: '2.4/subscriptions/search/', search: 'Reference'}, this.clearSearch()) }}><i className='fa fa-fw fa-handshake-o' /></a>
              <a onClick={() => { this.setState({icon: 'fa-ticket', endpoint: '2.4/tickets/search/', search: 'Tickets', pathparam: false}, this.clearSearch()) }}><i className='fa fa-fw fa-ticket' /></a>
              <a onClick={() => { this.setState({icon: 'fa-exchange', endpoint: '2.4/option82/', search: 'Option 82', pathparam: true}, this.clearSearch()) }}><i className='fa fa-fw fa-exchange' /></a>
              <a onClick={() => { this.setState({icon: 'fa-cog', endpoint: '2.4/orderevents/search/', search: 'Internal Reference'}, this.clearSearch()) }}><i className='fa fa-fw fa-cog' /></a>
            </div>
          </span>
          <input
            ref={el => (this.searchField = el)}
            type='text'
            defaultValue={this.props.search.query}
            onChange={(e) => {
              this.handleChange(e)
            }}
            onFocus={e => this.setState({fieldFocused: true})}
            onBlur={e => this.setState({fieldFocused: false})}
            className='form-control navbar-search-field'
            placeholder={'Search ' + this.state.search} />
        </div>
        {this.state.loading && this.searchField.value.length !== 0 &&
          <div className='list-group flow-search-results small-search-results'>
            <div className='no-data-in-table-wrapper'>
              <div className='no-data-text-wrapper'>
                <i className='fa fa-circle-o-notch fa-spin' />
                <h3 className='text-center no-data-text'>Loading</h3>
              </div>
            </div>
          </div>
        }
        {!this.state.loading && this.props.search.results.length === 0 && this.searchField && this.state.fieldFocused && this.searchField.value.length !== 0 &&
          <div className='list-group flow-search-results small-search-results'>
            <div className='no-data-in-table-wrapper'>
              <div className='no-data-text-wrapper'>
                <i className='fa fa-exclamation' />
                <h3 className='text-center no-data-text'>No results</h3>
              </div>
            </div>
          </div>
        }
        <div className={'list-group flow-search-results small-search-results ' + ((this.props.search.results && this.props.search.results.length) && !this.state.loading && !(window.location.hash.indexOf('search') > -1) ? '' : 'hidden')}>
          {this.props.search.results && this.props.search.results.map((result) => {
            i += 1
            switch (this.state.search) {
              case 'Tickets':
                return <TicketResult clearSearch={e => this.clearSearch()} result={result} key={i} active={(i === this.state.location)} />
              case 'Reference':
                return <ReferenceResult clearSearch={e => this.clearSearch()} result={result} key={i} active={(i === this.state.location)} />
              case 'Accesses':
                return <AccessResult key={i} clearSearch={e => this.clearSearch()} result={result} active={(i === this.state.location)} />
              case 'Internal Reference':
                return <OrderEventResult key={i} clearSearch={e => this.clearSearch()} result={result} active={(i === this.state.location)} />
              default:
                return <AccessResult key={i} clearSearch={e => this.clearSearch()} result={result} active={(i === this.state.location)} />
            }
          })}
          {this.state.totalResults > 10 &&
            <a href='/#/search' className='list-group-item text-right active list-group-item-results'>
              <h5 className='list-group-item-heading'>Show all {this.state.totalResults} results</h5>
            </a>
          }
          <div className='small-search-overlay' onClick={() => this.clearSearch()} />
        </div>
      </div>
    )
  }
}
// eslint-disable-next-line
SmallSearch = connect(state => state.siteReducer)(SmallSearch)
export default SmallSearch



// WEBPACK FOOTER //
// ./src/projects/access-gui/components/core/search/SmallSearch.js